
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { RouterModule } from "@angular/router";
import { EventsSearchInputComponent } from "@shared/components/events-search-input/events-search-input.component";
import { AuthService } from "../../../../app/services/auth.service";
import { ButtonComponent } from "../../button/button.component";
import { CityDropdownComponent } from "../city-dropdown/city-dropdown.component";
import { NavbarLinkGroup } from "../navbar.models";

@Component({
    selector: "app-hamburguer-menu",
    imports: [
    CityDropdownComponent,
    MatButtonModule,
    MatIconModule,
    ButtonComponent,
    RouterModule,
    EventsSearchInputComponent
],
    templateUrl: "./hamburguer-menu.component.html",
    styleUrl: "./hamburguer-menu.component.scss"
})
export class HamburguerMenuComponent implements OnInit {
  @Input() isLoggedIn = false;
  @Input() isSeller = false;

  @Output() closeMenu = new EventEmitter();
  @Output() loginClick = new EventEmitter();
  @Output() signUpClick = new EventEmitter();
  @Output() logoutClick = new EventEmitter();
  @Output() myAcountClick = new EventEmitter();

  private readonly _authService = inject(AuthService);

  isProducerArea = true;

  linkGroups: NavbarLinkGroup[] = [
    {
      groupName: "Pessoal",
      collapsed: false,
      links: [
        {
          label: "Meus ingressos",
          path: "/my-orders",
          producerOnly: false,
          icon: "pi pi-ticket",
        },
        {
          label: "Meus convites",
          path: "/my-invitations",
          producerOnly: false,
          icon: "pi pi-gift",
        },
        {
          label: "Eventos favoritos",
          path: "/favorite-events",
          producerOnly: false,
          icon: "pi pi-sparkles",
        },
        {
          label: "Produtores seguidos",
          path: "/followed-producers",
          producerOnly: false,
          icon: "pi pi-users",
        },
      ],
    },
  ];

  isAcountGroupCollapsed = true;

  ngOnInit(): void {
    const userRoles = this._authService.getCurrentUserRoles();

    if (this.isSeller) {
      this.linkGroups[0].links.unshift({
        label: "Vender",
        path: "/seller-events",
        producerOnly: false,
        icon: "pi pi-cart-plus",
      });
    }

    if (userRoles.includes("organizer")) {
      this.linkGroups.push({
        groupName: "Área do produtor",
        collapsed: true,
        links: [
          {
            label: "Resumo geral",
            path: "/producer-area",
            producerOnly: true,
            icon: "pi pi-chart-bar",
          },
          {
            label: "Criar evento",
            path: "/create-event",
            producerOnly: true,
            icon: "pi pi-plus",
          },
          {
            label: "Meus eventos",
            path: "/my-events",
            producerOnly: true,
            icon: "pi pi-calendar",
          },
          {
            label: "Minha página",
            path: "/my-page",
            producerOnly: true,
            icon: "pi pi-home",
          },
          {
            label: "Carteira",
            path: "/wallet",
            producerOnly: true,
            icon: "pi pi-wallet",
          },
          {
            label: "Solicitações",
            path: "/solicitations",
            producerOnly: true,
            icon: "pi pi-list-check",
          },
        ],
      });
    }
  }

  toggleGroup(group: NavbarLinkGroup) {
    group.collapsed = !group.collapsed;
  }

  toggleAcountGroup() {
    this.isAcountGroupCollapsed = !this.isAcountGroupCollapsed;
  }

  handleCloseMenu() {
    this.closeMenu.emit();
  }

  handleLoginClick() {
    this.loginClick.emit();
    this.closeMenu.emit();
  }

  handleSignUpClick() {
    this.signUpClick.emit();
    this.closeMenu.emit();
  }

  handleLogoutClick() {
    this.logoutClick.emit();
    this.closeMenu.emit();
  }

  handleMyAcountClick() {
    this.myAcountClick.emit();
    this.closeMenu.emit();
  }
}
